'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const ActionStatus = require('balus/domain/entity/action-status');
const API = require('balus/infra/api/my/action-status');

const repositories = {};

class Repository {
    constructor(group) {
        this._group = group;
        this._key = this._group ? this._group.key : null;
        this._initialFetched = false;
        this._actionStatuses = new Backbone.Collection([], {model: ActionStatus});
    }

    fetchOnce(limit) {
        if(this._initialFetched) {
            return new Promise((resolve, reject) => {
                resolve(this._actionStatuses);
            });
        } else {
            const promise = this.fetchNext(limit);
            promise.then(() => {
                this._initialFetched = true;
            });
            return promise;
        }
    }

    fetchNext(limit) {
        return API.fetchNext(this._key, limit)
            .then(actionStatusesJSON => {
                this._actionStatuses.add(actionStatusesJSON, {merge: true});
                return this._actionStatuses;
            });
    }

    hasNext() {
        return API.hasNext(this._key);
    }

    static find(group) {
        const key = group ? group.key : null;
        let r = repositories[key];
        if (!r) {
            r = new Repository(group);
            repositories[key] = r;
        }
        return r;
    }
}

module.exports = Repository;



// WEBPACK FOOTER //
// ./balus/domain/repository/my/action-status.js